import React from "react";

const About = ({ data }) => {
  if (!data) {
    return null;
  }

  return (
    <section id="about" className="about-section section-shell">
      <div className="section-kicker">How I work</div>
      <div className="about-grid">
        <div className="about-heading" data-reveal>
          <h2>Engineering that carries product responsibility.</h2>
        </div>

        <div className="about-content" data-reveal style={{ "--reveal-delay": "100ms" }}>
          <p>{data.bio}</p>

          <ol className="focus-list">
            {(data.focusAreas || []).map((focus, index) => (
              <li key={focus}>
                <span>0{index + 1}</span>
                <strong>{focus}</strong>
              </li>
            ))}
          </ol>

          <div className="about-contact-line">
            <a href={`mailto:${data.email}`}>{data.email}</a>
            <span aria-hidden="true">/</span>
            <a href={`tel:${data.phone.replace(/\s/g, "")}`}>{data.phone}</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
